// plan-12 S02: vertical hold drift — periodic 1px sinusoidal vertical offset

import type { DrawPass } from '../canvas'

const MIN_INTERVAL = 18_000
const MAX_INTERVAL = 32_000
const EVENT_DURATION = 960
const AMPLITUDE = 1

export function createVerticalHold(reduced: boolean): DrawPass {
  if (reduced) return () => {}

  let nextEvent = performance.now() + randomInterval()
  let eventStart = 0
  let active = false

  function randomInterval(): number {
    return MIN_INTERVAL + Math.random() * (MAX_INTERVAL - MIN_INTERVAL)
  }

  return (ctx, _w, _h, t): void => {
    const now = t * 1000

    if (!active && now >= nextEvent) {
      // skip if input has focus (don't disturb someone typing)
      const ae = document.activeElement
      if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA')) {
        nextEvent = now + randomInterval()
        return
      }
      active = true
      eventStart = now
    }

    if (active) {
      const elapsed = now - eventStart
      if (elapsed < EVENT_DURATION) {
        const progress = elapsed / EVENT_DURATION
        const offset = Math.sin(progress * Math.PI * 2) * AMPLITUDE * (1 - progress)
        ctx.translate(0, offset)
      } else {
        active = false
        nextEvent = now + randomInterval()
      }
    }
  }
}
